import confetti from 'canvas-confetti';
import emailjs from 'emailjs-com';
import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

export default function Footer() {
    const formId = 'contact-form';
    const templateId = 'template_qodwpvm';

    const handleSubmit = (e) => {
        e.preventDefault();
        const getFullName = () => e.target.elements.name.value;
        const getEmail = () => e.target.elements.email.value;
        const getMessage = () => e.target.elements.message.value;

        emailjs.send('service_zq8yej5', templateId, {
            from_name: getFullName(),
            from_email: getEmail(),
            to_name: 'RealTech Support Team:',
            message: getMessage()
        }, '50to_FF6RY92PYjmM')
            .then(function () {
                confetti({
                    particleCount: 1000,
                    spread: 70,
                    origin: { y: 0.6 }
                });
                toast.success('🎉 Message sent! A real human will contact you within 24 hours.');
                e.target.reset();
            }, function (error) {
                toast.error('❌ Failed to send. Shoot us an email with this error message and we may pay you for discovering the error: ' + error.text);
            });
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                <section id="contact" className="contact-wrapper">
                    <form className="contact-form" id={formId} onSubmit={handleSubmit}>
                        <h2>Get a Demo / Contact Us</h2>
                        <input type="text" name="name" placeholder="Your Name" required />
                        <input type="email" name="email" placeholder="Your Email" required />
                        <textarea name="message" placeholder="Your Message" required></textarea>
                        <button type="submit">Submit</button>
                    </form>
                </section>

                <div className="footer-content">
                    <p><strong>Address:</strong> 1451 Elm Hill Pike Suite 218, Nashville, TN 37210</p>
                    <p><strong>Phone:</strong> <a href="tel:6157080787">615-708-0787</a></p>
                    <p><strong>Email:</strong> <a href="mailto:support@real-tech.org">support@real-tech.org</a></p>
                    <p>&copy; {new Date().getFullYear()} RealTech LLC — All rights reserved.</p>
                </div>
            </div>

            <Toaster position="top-center" toastOptions={{ duration: 10000 }} />
        </footer>
    );
}
